import clsx, { ClassValue } from 'clsx';
import { FC } from 'react';

interface ISvg {
  className?: ClassValue;
}

export const SvgSidePatient: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 25 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.2221 9.77778C12.9222 9.77778 15.111 7.58895 15.111 4.88889C15.111 2.18883 12.9222 0 10.2221 0C7.52208 0 5.33325 2.18883 5.33325 4.88889C5.33325 7.58895 7.52208 9.77778 10.2221 9.77778Z" />
    <path d="M10.6499 12.2344C7.31323 12.1122 0.444336 13.7744 0.444336 17.1111V19.5555H12.1043C9.08545 16.1822 10.601 12.3567 10.6499 12.2344Z" />
    <path d="M21.7479 17.1355C22.1879 16.4144 22.4445 15.571 22.4445 14.6666C22.4445 11.9655 20.2567 9.77771 17.5556 9.77771C14.8545 9.77771 12.6667 11.9655 12.6667 14.6666C12.6667 17.3677 14.8545 19.5555 17.5556 19.5555C18.4601 19.5555 19.3034 19.2866 20.0245 18.8588L23.1656 21.9999L24.889 20.2766L21.7479 17.1355ZM17.5556 17.111C16.2112 17.111 15.1112 16.011 15.1112 14.6666C15.1112 13.3222 16.2112 12.2222 17.5556 12.2222C18.9001 12.2222 20.0001 13.3222 20.0001 14.6666C20.0001 16.011 18.9001 17.111 17.5556 17.111Z" />
  </svg>
);

export const SvgSideHealth: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M29.125 10.375h-7.5v-7.5c0-1.036-0.839-1.875-1.875-1.875h-7.5c-1.036 0-1.875 0.84-1.875 1.875v7.5h-7.5c-1.036 0-1.875 0.84-1.875 1.875v7.5c0 1.036 0.84 1.875 1.875 1.875h7.5v7.5c0 1.036 0.84 1.875 1.875 1.875h7.5c1.036 0 1.875-0.84 1.875-1.875v-7.5h7.5c1.035 0 1.875-0.839 1.875-1.875v-7.5c0-1.036-0.84-1.875-1.875-1.875z" />
  </svg>
);

export const SvgSideVideo: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 18 12"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M0 2C0 0.896875 0.896875 0 2 0H10C11.1031 0 12 0.896875 12 2V10C12 11.1031 11.1031 12 10 12H2C0.896875 12 0 11.1031 0 10V2ZM17.4719 1.11875C17.7969 1.29375 18 1.63125 18 2V10C18 10.3688 17.7969 10.7063 17.4719 10.8813C17.1469 11.0563 16.7531 11.0375 16.4438 10.8313L13.4438 8.83125L13 8.53438V8V4V3.46562L13.4438 3.16875L16.4438 1.16875C16.75 0.965625 17.1437 0.94375 17.4719 1.11875Z" />
  </svg>
);
export const SvgSideBox: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M18.283 3.59226L16.0302 2.41179C14.0526 1.37555 13.0639 0.857422 12.0002 0.857422C10.9365 0.857422 9.94774 1.37555 7.97019 2.41179L5.71735 3.59226C3.71938 4.6392 2.54492 5.25462 1.81702 6.07773L12.0002 11.1618L22.1833 6.07773C21.4554 5.25462 20.281 4.6392 18.283 3.59226Z" />
    <path d="M22.5774 6.85742L12.5714 12.0216V22.8574C13.3697 22.6522 14.2781 22.1601 15.7157 21.3813L17.9397 20.1767C20.3323 18.8806 21.5285 18.2327 22.1928 17.0682C22.8571 15.9038 22.8571 14.4547 22.8571 11.5567V11.4224C22.8571 9.25008 22.8571 7.89186 22.5774 6.85742Z" />
    <path d="M11.4285 22.8574V12.0216L1.42264 6.85742C1.14282 7.89186 1.14282 9.25009 1.14282 11.4224V11.5567C1.14282 14.4547 1.14282 15.9038 1.80711 17.0682C2.47139 18.2327 3.66769 18.8806 6.06027 20.1767L8.28421 21.3813C9.72193 22.1601 10.6303 22.6522 11.4285 22.8574Z" />
  </svg>
);

export const SvgSideExpand: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 16 16"
    fill="current"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="16" height="16" fill="url(#patternE)" />
    <defs>
      <pattern id="patternE" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_644_5350" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_644_5350"
        width="512"
        height="512"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const SvgSideConsultations: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3_529)">
      <path d="M5.77767 13.7222V7.94446H3.611C3.03637 7.94446 2.48527 8.17273 2.07894 8.57906C1.67261 8.98539 1.44434 9.53649 1.44434 10.1111V23.1111C1.44541 23.2453 1.48382 23.3764 1.55525 23.49C1.62669 23.6035 1.72833 23.6949 1.84878 23.7539C1.96483 23.8067 2.09277 23.8278 2.21962 23.8151C2.34647 23.8024 2.4677 23.7564 2.571 23.6817L6.29045 20.9445H15.9971C16.2708 20.9526 16.5433 20.9044 16.7977 20.8029C17.052 20.7014 17.2828 20.5487 17.4758 20.3544C17.6687 20.1601 17.8197 19.9282 17.9195 19.6732C18.0192 19.4182 18.0655 19.1453 18.0554 18.8717V18.0556H10.111C8.96173 18.0556 7.85953 17.599 7.04687 16.7864C6.23422 15.9737 5.77767 14.8715 5.77767 13.7222Z" />
      <path d="M22.3888 2.88892H10.111C9.53637 2.88892 8.98527 3.11719 8.57894 3.52352C8.17261 3.92985 7.94434 4.48095 7.94434 5.05558V13.7222C7.94434 14.2969 8.17261 14.848 8.57894 15.2543C8.98527 15.6606 9.53637 15.8889 10.111 15.8889H19.8971L23.3493 18.5684C23.452 18.6442 23.5729 18.6916 23.6997 18.7055C23.8266 18.7195 23.9549 18.6996 24.0716 18.6478C24.1945 18.5893 24.2983 18.4972 24.3712 18.3822C24.444 18.2672 24.4828 18.1339 24.4832 17.9978V5.05558C24.4835 4.49324 24.2652 3.95281 23.8744 3.5485C23.4835 3.14418 22.9508 2.90766 22.3888 2.88892Z" />
    </g>
    <defs>
      <clipPath id="clip0_3_529">
        <rect width="26" height="26" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgSideAdmin: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g clipPath="url(#clip0_736_2476)">
      <rect y="0.5" width="16" height="16" fill="url(#patternAd)" />
    </g>
    <defs>
      <pattern id="patternAd" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_736_2476" transform="scale(0.01)" />
      </pattern>
      <clipPath id="clip0_736_2476">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
      <image
        id="image0_736_2476"
        width="100"
        height="100"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAMSElEQVR4nO2da5BcZZnHf8853Z3L5GIIaJAkuoKQsvjAmgi4KFtZqxYqM7OYqOGSpOcSwpBEUFFx1VIGqVqvhRKJEiFzZnomAtk1kuqeUdQyeCuzJNn1TuElVOQW5JIwuc2l+332Q2fY7pnp7pnu855zkvirmg99+vTz/Lv/857z3o8QQbZty8wZGnJnEzczJSvHVQdfbmlZfjhsXUEgYQvwvN5LxOVKo3qFiCwCvQCYPs6pRmA/Kj8z6E+G49rbdkPjS0HrtU0ohtz/7Z1vcLPuBgduULigyjADAt5gTD97OhkTqCE9PX2zho25E2gDpvkU9nlFlrcm6//bp3ihEpghnT3p96hxPNAFFsIfBr3dxE3v2uuvec5C/MAIxBAvlV4nyDcUYpZTKfA46Odako19lnNZwbohXlemFWGr7TyjUdiVi+WuX3fDNS8EnbsWrBrS2dl7pTr6IyBuM08ZDuSg4cZkw+9Cyj9prBmyffv2accHpv+mhlqUT8jTQzHz9lOlJubYCnx0YPqnwzcDQBckstIdtoqJYqWEbN26c6YTd/8KvM5G/GpwVFc0NTV+N2wdlbBSQpyY20yEzAAwIv8etoaJYOeSJXzAStzauLSjp+9tYYuohO+G9PT0zQIu9zuuH0jOvCdsDZXw3ZCsmncTXjW3PCL/EraESvh/yVIW+R7TPxaHLaASvhti4EK/Y/qFoOdu377dDVtHOXw3xEHf6HdMv1CIHTtWd07YOsrhuyE6/uBSZDAxZ3bYGsphodordf7H9A9lKBe2hnJYuKmr+h7TRxzHNWFrKIf/hoi86ntMH4nl4kfD1lAOGy31fgsx/WJ4//5fRrrX13dDBCL7hQVeaG9vP7MuWUbY73dMv1D4c9gaKuG7Ia7Rv/gd0z/092ErqISFe4iJrCGqzm/D1lAJ3w0ZGDjvCeCE33H9wNHcz8PWUAnfDWlrWzKM6q/9jlsrAi81NTX+IWwdlbAyQKXC4zbi1oLCT0Uk0o1WsGSIKIdsxK0FhafC1jARfJ/k0NHRd47EzFNA1Pq0jrnE35JMXvW3sIWUw/+GYcysInpmANRlya4KW0Ql/DdEudTvmH7hqL4jbA2V8H88RIjseIMKs8LWUIkzrXPxSNgCKmGh+51f+R7TL1T+J2wJlfB/TN1Erw0ygkoustpG8P+mLvHHgSgOUh0ePiF7whZRCd8NSSavOobot/yOWzPKlra2xuNhy6iEnbm9Wedu4KCV2NXxfDae+2rYIiaCFUNaWuoPOqorgFdsxJ8kLyuy/FRZ2mZ1SdvWB3e+0Rl2n4DQ6v9HTDy36FRamWttBRXA2uuveU6Vx2zmKIcqu04lM8CyIQCOyA9s5yidXH8YWu4qsW6I5vgOMGQ7z2gEsq4h8kvYRmPdkJaW+oMggf8wCr1NTY3PBp23VqwbAiBGvh5EnuKc+o2gc/pBIIY0Ny/7BbAziFx55CfNzY3h3btqIBBDAByV2wnmXmIMfCyAPFYIzJCmpvo/gn7IeiLVu9Ym6/daz2OJwAwBaEk23gfyiLUEwr4DT+37nLX4AWB7u6SxKAes9Q+oPO3HZGrP652nMZaiXCLoPwJvAmaf/HOAY8CL5GeyPKGqu3Nx85gf3TOBG6JiRCw5olL9YqEHHvj+WW58uBlHVqD6TtGyV48EMIf8AterRIRY1lUvlXlckO7skPvgjTdeXVU/XuCGCGKt/0xUJ106urrS56nIRyG7TpEZVD+VToDLFL3MTWS/6HX3bonhfmXNmqufn0yQEAwhFoXpg1u27I3Hpx/8kFHa8X/aUh2qt+XI3tTRnblz+Pi8e9ralgxP5IOB3tQBFJ1hL/rEFpx6XnpRYtoLe0X5MuObYVDdjfIfwPvEmIsTLmcNnZiXGDoxL5FwOUuMuRh4nyCfR3U3MKZ0KswQ5cuJaQd3P9C9c0JbVQV/U0esdcULVDS7szvzb6p0g47RIfCMIpsdNd0Vul0Onfz7PbAD4P6evvkxo6sF3agwf9T5b3fV3eel0qtbko3pcvoCLyEC59mKrcobyr3vpdI3q/IIY8dnXgZdP33q8fNbkvVfqKYPbN3qZc+0JOu/0H/YuUCFDfmYRcwSZEdnKrO2XJxA9+3t7O5dqaoP28whok3NaxpTY3NnblLlPsZ+54ccHfpgU9OK0T9gTWz5dvrs+LBsFmHlqLdUYF1zsmHcjUEDM8Tr7r0a1R34t4FyKQZFdG3zmsZtIwe6utLLjch3KPi+AllFb8k3Vu3hdWU2iHBP4Ra5J3OvGO/yZd2Q/GaYdZ9R9HYgqI1fVNGvD0+d+tnE8MDryckeKJriekJVVrY21WeCEOOl0o0gD1P8z/iqGGdxc/OyoiWA1gzZtKlvyow5plWUT5Bv6YbBCyj9CG8dOSCQNSrLgzJjBC+VbhRkR9Fm0sK+A/PrLm9fujRboM9furp2zM05iRYxfAQhgjsD6Xrbl6lSdKZ6Nyp6b5Ea5LbWZP1rU5R8M6SjO/NPonozyAeAqX7F9ZmHWpIN11fzQS+VKWrPtiQbqvrtvFRmOxTtSXmEnFyYH1mtsR2yZfsPZ08ZHLxWYT3KJRF4HEk5XhmK6S1hi3B0aL1KYqnC2ScPzSRmbgNuhyrbIZ6XXuR1Z+5LDAw+p8qWvBlRRz8dhd2tm5pWvGxE7yw8Jirrt23LzIFJlpDOzsxiHG1XZBnle0MjhcAz06ee6AhbxwhHD7n3z5xtPjlyj1WYMWi4DvjmhH7Uzs6+871U5kF12KNIAyG08GtBkc0rV64MfCpSKW69ddkgDpsLj4nRJFQoIe3t7c6b/uEdH1UxdwFTLGq0Sc5RE7m9313VnhxyFyP/3CKXdXT0nVPyPz2VSi9c+JYlP0L0S5y6ZoDqnijOz0omG/8KFI79ixPXpeMa0pHqvSyH7BVYGow8m8iPw1ZQEmVX8Wu9fMwlq7Oz7wrFPEo015pPHmFf2BJKoejewuFshYuKSsjW7u9dpI7JcLqYAYgxT4atoRTiOsXalLe+VkLynYC5/9KIPWaiVrLZRNkx7dEt8Iky0c+Va9EPOeb5hPn/t0WY81oJOT4w7VMKF1cjLsrMmtUf2V1IB19yi9bNK8x04OTMC+Tj4cj6O4U4AIp8mFO5aluG/v5ZFidV1MaUs3MzC18LHIm179oV06ePNYUlyjax2NC5lFl8OtFeW796ewtJGOdcCiaCqXLIefOzR/8ZiPQTA2pBHeeisDWUQnOmWJvwJ8cYuTIkPYEgyJKwNZRitDaBJx0huvtb+YGqiW5vw6hHMCn80kE5Pyw9gSByaUfHIzaeUF0TqVR6IWjhI5hUs85jDmJv4lpEcCQWj9zWfjmR1RQMYyjsbm1d9qJDxJ+I4weCbty0qS8y1fpNm/qmoGwoPCZoCk6xgaZqUZg/Y45pDVvHCDNnm5sonlJ7JOHKwxDxWQm10JHq/aLkJ+eN8IpmnUWtrcterCaeX+2Qrq4dc40kngTmjhxT5EutyfpPwGlcQiQ39HmKJzyfhWvuLXV+UKiTuI8CM4D+XCx798iL07aEAHipzIeB4n2ylI0tTQ2hbCrgdWVuQdg06vBHWpINXxt5cdqWEIADC+ruFSh6IoII9+Tn2gaLl0o3inB38VHZc2BBXVGpPa1LCOQX0sSN+d+CiWkAJ0CvrbR4xi9KTLY+rC6LW1c1FD2R6LQuIZBfSKMiawSyBYen5RfP9G60nd/rytwiSNEyDIGsCKtHm3HyvTODjq70tY5Ij46d+vSfmnU2Vlv7KkUq9ejrjQxvVuX9o95SFV3buqbRG+9zZ4whAF4qcx3Qw9h1Kq+o6B1HD7n333rrssGacni7puIcW4dwJ/m17K8hkDWiN5Uy4+Q5Zxadnel/VUd6GG/IQXkOh806nO1ubX3v05OJm0qlFxpkjSobSizDeFWEVc1rGnrLxTnjDIGTK2bVPIRyRYlTDLAX9Meq7BPXeTI34D47Mj7f3z9rRjw+OD+Hc6EgS/K9trqYkvdk2aOuXjfePWPMmVV+p1Oe9l27YgufOXqzo3LHqBqYn/QDdxxYUHdv4Sqpcpyxhozged99HbHYp1Bpw6ftbAWOqug3XU18ZbJP9DnjDRkhlXq0LqvD7xdhLfAuJv/bqMJuhO4pDg+tWtVQ1XO4/m7IOHR17ZirTuJyo7xTYDHCPFTmgp5NvoZ2BPQlFfYLzhOo7tas85gfVef/Ayq2OhhrXVDtAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
);

export const SvgSideProducts: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 26 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.5829 0.589572C22.274 0.176872 20.8355 0 19.4559 0C17.1566 0 14.6803 0.471658 12.9706 1.76872C11.2608 0.471658 8.78463 0 6.48529 0C4.18596 0 1.70976 0.471658 0 1.76872V19.0432C0 19.338 0.294786 19.6328 0.589572 19.6328C0.707487 19.6328 0.766444 19.5738 0.884358 19.5738C2.4762 18.8074 4.77553 18.2767 6.48529 18.2767C8.78463 18.2767 11.2608 18.7484 12.9706 20.0455C14.5624 19.0432 17.4513 18.2767 19.4559 18.2767C21.4015 18.2767 23.406 18.6305 25.0568 19.5148C25.1747 19.5738 25.2337 19.5738 25.3516 19.5738C25.6464 19.5738 25.9412 19.279 25.9412 18.9842V1.76872C25.2337 1.2381 24.4672 0.884358 23.5829 0.589572ZM23.5829 16.508C22.2858 16.0953 20.8709 15.9185 19.4559 15.9185C17.4513 15.9185 14.5624 16.6849 12.9706 17.6872V4.12701C14.5624 3.12473 17.4513 2.35829 19.4559 2.35829C20.8709 2.35829 22.2858 2.53516 23.5829 2.94786V16.508Z" />
    <path d="M19.4563 7.07481C20.4939 7.07481 21.4962 7.18093 22.4042 7.38139V5.58909C21.4726 5.41221 20.4704 5.30609 19.4563 5.30609C17.4518 5.30609 15.6359 5.64804 14.1501 6.28478V8.24216C15.4826 7.48751 17.3338 7.07481 19.4563 7.07481Z" />
    <path d="M14.1501 9.42132V11.3787C15.4826 10.624 17.3338 10.2113 19.4563 10.2113C20.4939 10.2113 21.4962 10.3175 22.4042 10.5179V8.72562C21.4726 8.54875 20.4704 8.44263 19.4563 8.44263C17.4518 8.44263 15.6359 8.79637 14.1501 9.42132Z" />
    <path d="M19.4563 11.591C17.4518 11.591 15.6359 11.933 14.1501 12.5697V14.5271C15.4826 13.7724 17.3338 13.3597 19.4563 13.3597C20.4939 13.3597 21.4962 13.4658 22.4042 13.6663V11.874C21.4726 11.6853 20.4704 11.591 19.4563 11.591Z" />
  </svg>
);

export const SvgFileUpload: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 38 38"
  >
    <path d="M27.42,1.66H11.81a2,2,0,0,0-2,2v2H4.33A2.42,2.42,0,0,0,1.91,8v26.4a2.42,2.42,0,0,0,2.42,2.42H22.44a2.42,2.42,0,0,0,2.42-2.42v-1.3h9a2,2,0,0,0,1.95-1.95V10ZM22.86,34.42a.42.42,0,0,1-.42.42H4.33a.42.42,0,0,1-.42-.42V8a.42.42,0,0,1,.42-.42H9.86V31.17a2,2,0,0,0,2,1.95h11Zm6.67-14.11H25.07v7.74a.3.3,0,0,1-.3.3h-3.4a.29.29,0,0,1-.3-.3V20.31H16.61a.33.33,0,0,1-.25-.55l3.12-3.62,3.34-3.89a.33.33,0,0,1,.5,0l3.34,3.89,3.12,3.62A.33.33,0,0,1,29.53,20.31Zm4.35-9.54H27.05a.37.37,0,0,1-.37-.36V3.58a.37.37,0,0,1,.63-.26l6.83,6.83A.36.36,0,0,1,33.88,10.77Z"></path>
  </svg>
);

export const SvgScriptFile: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
  >
    <path
      id="contract"
      d="M27,31.36H8c-0.199,0-0.36-0.161-0.36-0.36v-1.64H6c-0.199,0-0.36-0.161-0.36-0.36v-1.64H5
	c-0.199,0-0.36-0.161-0.36-0.36V3c0-0.199,0.161-0.36,0.36-0.36h4.64V2c0-0.199,0.161-0.36,0.36-0.36h1.64V1
	c0-0.199,0.161-0.36,0.36-0.36h4c0.199,0,0.36,0.161,0.36,0.36v0.64H18c0.199,0,0.36,0.161,0.36,0.36v0.64H23
	c0.199,0,0.36,0.161,0.36,0.36v1.64H25c0.199,0,0.36,0.161,0.36,0.36v1.64H27c0.199,0,0.36,0.161,0.36,0.36v24
	C27.36,31.199,27.199,31.36,27,31.36z M8.36,30.64h18.28V7.36h-1.28V29c0,0.199-0.161,0.36-0.36,0.36H8.36V30.64z M6.36,28.64h18.28
	V5.36h-1.28V27c0,0.199-0.161,0.36-0.36,0.36H6.36V28.64z M5.36,26.64h17.28V3.36h-4.28V4c0,0.199-0.161,0.36-0.36,0.36h-8
	C9.801,4.36,9.64,4.199,9.64,4V3.36H5.36V26.64z M10.36,3.64h7.28V2.36H16c-0.199,0-0.36-0.161-0.36-0.36V1.36h-3.28V2
	c0,0.199-0.161,0.36-0.36,0.36h-1.64C10.36,2.36,10.36,3.64,10.36,3.64z M20.5,21.36h-13v-0.72h13V21.36z M20.5,17.36h-13v-0.72h13
	V17.36z M20.5,13.36h-13v-0.72h13V13.36z M20.5,9.36h-13V8.64h13V9.36z"
    />
    <rect id="_Transparent_Rectangle" />
  </svg>
);

export const SvgPrescription: FC<ISvg> = ({ className }) => {
  return (
    <svg
      width="26"
      height="20"
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, 'fill-current')}
    >
      <path
        d="M2.88847 4.99482C2.88847 3.81301 3.85882 2.85418 5.05482 2.85418C6.25083 2.85418 7.22117 3.81301 7.22117 4.99482V9.98964H2.88847V4.99482ZM0 4.99482V14.9845C0 17.745 2.26113 19.9793 5.05482 19.9793C7.84851 19.9793 10.1096 17.745 10.1096 14.9845V7.02843C10.1909 7.88022 10.4797 8.7231 11.0033 9.47232L16.8028 17.8253C18.405 20.1309 21.5552 20.6928 23.8434 19.0784C26.1316 17.464 26.6868 14.2843 25.0846 11.9787L19.285 3.62571C17.6829 1.3156 14.5281 0.758142 12.2444 2.37254C10.9807 3.26447 10.245 4.63805 10.1096 6.07406V4.99482C10.1096 2.23429 7.84851 0 5.05482 0C2.26113 0 0 2.23429 0 4.99482ZM13.3863 7.85792C12.6641 6.81882 12.9349 5.39173 13.9233 4.69156C14.8801 4.01816 16.2025 4.23222 16.9021 5.23564L19.9259 9.58827L16.3199 12.0857L13.3863 7.85792ZM22.16 16.755C22.1239 16.7817 22.0878 16.804 22.0517 16.8263L22.2322 16.7014C22.2096 16.7193 22.1871 16.7371 22.16 16.755Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SvgOrders: FC<ISvg> = ({ className }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
  >
    <g clipPath="url(#clip0_6870_4480)">
      <path
        d="M5 3.5C5 2.39688 5.89688 1.5 7 1.5
           C8.10312 1.5 9 2.39688 9 3.5V5H5V3.5ZM3.5 5H1.5
           C0.671875 5 0 5.67188 0 6.5V13C0 14.6562 1.34375 16 3 16H11
           C12.6562 16 14 14.6562 14 13V6.5C14 5.67188 13.3281 5 12.5 5H10.5V3.5
           C10.5 1.56562 8.93438 0 7 0C5.06562 0 3.5 1.56562 3.5 3.5V5ZM4.25 6.5
           C4.44891 6.5 4.63968 6.57902 4.78033 6.71967
           C4.92098 6.86032 5 7.05109 5 7.25
           C5 7.44891 4.92098 7.63968 4.78033 7.78033
           C4.63968 7.92098 4.44891 8 4.25 8
           C4.05109 8 3.86032 7.92098 3.71967 7.78033
           C3.57902 7.63968 3.5 7.44891 3.5 7.25
           C3.5 7.05109 3.57902 6.86032 3.71967 6.71967
           C3.86032 6.57902 4.05109 6.5 4.25 6.5ZM9 7.25
           C9 7.05109 9.07902 6.86032 9.21967 6.71967
           C9.36032 6.57902 9.55109 6.5 9.75 6.5
           C9.94891 6.5 10.1397 6.57902 10.2803 6.71967
           C10.421 6.86032 10.5 7.05109 10.5 7.25
           C10.5 7.44891 10.421 7.63968 10.2803 7.78033
           C10.1397 7.92098 9.94891 8 9.75 8
           C9.55109 8 9.36032 7.92098 9.21967 7.78033
           C9.07902 7.63968 9 7.44891 9 7.25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6870_4480">
        <rect width="14" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const SvgCoupon: FC<ISvg> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
  >
    <path
      d="M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM11 17H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V7h2v2z"
      fill="currentColor"
    />
  </svg>
);
export const SvgInbox: FC<ISvg> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
  >
    <path
      d="M1.60156 4.20114C2.14978 3.47258 3.02139 3 3.99981 3H19.9998C20.9782 3 21.8498 3.47258 22.398 4.20113L11.9998 11.7635L1.60156 4.20114Z"
      fill="currentColor"
    />
    <path
      d="M1 6.23634V17.9998C1 19.6521 2.34772 20.9998 4 20.9998H20C21.6523 20.9998 23 19.6521 23 17.9998V6.23633L13.1763 13.3808C12.475 13.8908 11.525 13.8908 10.8237 13.3808L1 6.23634Z"
      fill="currentColor"
    />
  </svg>
);
export const SvgProfile: FC<ISvg> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
  >
    <path
      d="M15.7127 9.53236C16.8245 8.53088 17.5296 7.08459 17.5296 5.46999
         C17.529 2.4483 15.0797 0 12.0585 0
         C9.03737 0 6.58802 2.44882 6.58802 5.46999
         C6.58802 7.0825 7.29 8.52775 8.4002 9.52923
         C5.55623 9.7498 3.30917 12.1051 3.28878 15.0055
         L3.25324 20.9882
         C3.24801 21.7853 3.56163 22.5511 4.12352 23.1166
         C4.68542 23.6812 5.4496 23.9995 6.2467 23.9995
         H11.5526H17.7172
         C19.3637 23.9995 20.7013 22.6703 20.7117 21.0238
         L20.7473 15.0855
         C20.7582 13.6083 20.1781 12.1908 19.1358 11.1423
         C18.2164 10.215 17.0011 9.65154 15.7127 9.53236Z"
      fill="currentColor"
    />
  </svg>
);

export const SvgUserManagement: FC<ISvg> = ({ className }) => (
  <svg
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
  >
    <g clipPath="url(#clip0_408_457)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83337 11.084C5.83337 8.18449 8.18388 5.83398 11.0834 5.83398C13.9829 5.83398 16.3334 8.18449 16.3334 11.084C16.3334 13.9835 13.9829 16.334 11.0834 16.334C8.18388 16.334 5.83337 13.9835 5.83337 11.084Z"
        fill="currentColor"
      />
      <path
        d="M16.7621 14.0737C16.7091 14.1743 16.7316 14.2997 16.8229 14.3674C17.5015 14.8696 18.3411 15.1667 19.2501 15.1667C21.5052 15.1667 23.3334 13.3385 23.3334 11.0833C23.3334 8.82817 21.5052 7 19.2501 7C18.3411 7 17.5015 7.29703 16.8229 7.79932C16.7316 7.86699 16.7091 7.99234 16.7621 8.09292C17.2334 8.98589 17.5001 10.0035 17.5001 11.0833C17.5001 12.1632 17.2334 13.1808 16.7621 14.0737Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41464 18.3158C6.85239 17.6918 8.73882 17.5 11.0832 17.5C13.4297 17.5 15.3175 17.6921 16.7557 18.3176C18.3225 18.9988 19.2747 20.1592 19.7738 21.7975C20.0077 22.5654 19.4309 23.3333 18.6361 23.3333H3.53264C2.73683 23.3333 2.15882 22.5643 2.39346 21.795C2.89322 20.1564 3.8469 18.9964 5.41464 18.3158Z"
        fill="currentColor"
      />
      <path
        d="M17.2883 16.3754C16.8053 16.4053 16.7769 17.0542 17.2207 17.2472C18.4368 17.7761 19.3526 18.5546 20.0093 19.5482C20.5482 20.3636 21.385 20.9996 22.3623 20.9996H24.4397C25.2648 20.9996 25.8668 20.1797 25.5765 19.3788C25.5598 19.3327 25.5424 19.287 25.5245 19.2416C25.125 18.2329 24.4403 17.4903 23.4264 17.017C22.4746 16.5726 21.2829 16.3892 19.8791 16.3338L19.856 16.3329H19.833C19.0061 16.3329 18.1424 16.3223 17.2883 16.3754Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_408_457">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgSidePrescription: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.5 5H17.5V2.5C17.5 1.125 16.375 0 15 0H10C8.625 0 7.5 1.125 7.5 2.5V5H2.5C1.125 5 0 6.125 0 7.5V22.5C0 23.875 1.125 25 2.5 25H22.5C23.875 25 25 23.875 25 22.5V7.5C25 6.125 23.875 5 22.5 5ZM10 2.5H15V5H10V2.5ZM17.5 16.25H13.75V20H11.25V16.25H7.5V13.75H11.25V10H13.75V13.75H17.5V16.25Z" />
  </svg>
);

export const SvgUpload: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 133 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="133" height="95" fill="url(#pattern0)" fillOpacity="0.3" />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_155_676" transform="translate(0.142857) scale(0.00714286 0.01)" />
      </pattern>
      <image
        id="image0_155_676"
        width="100"
        height="100"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const SvgLefRightArrow: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.2639 5.33966L12.285 6.40435L14.7149 8.69187H4.28509L6.71488 6.40435L5.73611 5.33966L1.31946 9.4995L5.73611 13.6601L6.71488 12.5958L4.28686 10.3092H14.7132L12.285 12.5958L13.2639 13.6601L17.6806 9.4995L13.2639 5.33966Z" />
    <path
      d="M13.2639 5.33966L12.285 6.40435L14.7149 8.69187H4.28509L6.71488 6.40435L5.73611 5.33966L1.31946 9.4995L5.73611 13.6601L6.71488 12.5958L4.28686 10.3092H14.7132L12.285 12.5958L13.2639 13.6601L17.6806 9.4995L13.2639 5.33966Z"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgSideSettings: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2107)">
      <path d="M31.8999 21.5667C31.9665 21.0667 31.9999 20.55 31.9999 20C31.9999 19.4667 31.9665 18.9333 31.8832 18.4333L35.2665 15.8C35.5665 15.5667 35.6499 15.1167 35.4665 14.7833L32.2665 9.25C32.0665 8.88333 31.6499 8.76667 31.2832 8.88333L27.2999 10.4833C26.4665 9.85 25.5832 9.31667 24.5999 8.91667L23.9999 4.68333C23.9332 4.28333 23.5999 4 23.1999 4H16.7999C16.3999 4 16.0832 4.28333 16.0165 4.68333L15.4165 8.91667C14.4332 9.31667 13.5332 9.86667 12.7165 10.4833L8.73319 8.88333C8.36652 8.75 7.94986 8.88333 7.74986 9.25L4.56652 14.7833C4.36652 15.1333 4.43319 15.5667 4.76652 15.8L8.14986 18.4333C8.06652 18.9333 7.99986 19.4833 7.99986 20C7.99986 20.5167 8.03319 21.0667 8.11652 21.5667L4.73319 24.2C4.43319 24.4333 4.34986 24.8833 4.53319 25.2167L7.73319 30.75C7.93319 31.1167 8.34986 31.2333 8.71652 31.1167L12.6999 29.5167C13.5332 30.15 14.4165 30.6833 15.3999 31.0833L15.9999 35.3167C16.0832 35.7167 16.3999 36 16.7999 36H23.1999C23.5999 36 23.9332 35.7167 23.9832 35.3167L24.5832 31.0833C25.5665 30.6833 26.4665 30.15 27.2832 29.5167L31.2665 31.1167C31.6332 31.25 32.0499 31.1167 32.2499 30.75L35.4499 25.2167C35.6499 24.85 35.5665 24.4333 35.2499 24.2L31.8999 21.5667ZM19.9999 26C16.6999 26 13.9999 23.3 13.9999 20C13.9999 16.7 16.6999 14 19.9999 14C23.2999 14 25.9999 16.7 25.9999 20C25.9999 23.3 23.2999 26 19.9999 26Z" />
    </g>
    <defs>
      <clipPath id="clip0_1_2107">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgHazelBrand: FC<ISvg> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 61 20"
    className={clsx(className, 'fill-current')}
    role="img"
    aria-label="Hazel"
  >
    <path
      d="M26.9064 6.70919C25.732 5.52581 24.1159 4.88477 22.2598 4.88477C18.2089 4.88477 15.3801 7.87878 15.3801 12.1665C15.3801 16.4543 18.2089 19.3762 22.2598 19.3762C24.0235 19.3762 25.5738 18.7967 26.7206 17.7258V19.2095H29.269V5.07687H26.9892L26.9064 6.70919ZM26.7206 11.9744C26.7206 14.9101 24.908 16.9595 22.3118 16.9595C19.7156 16.9595 18.0326 14.9886 18.0326 12.1655C18.0326 9.34235 19.8133 7.30035 22.3639 7.30035C24.9144 7.30035 26.7206 9.22242 26.7206 11.9734V11.9744Z"
      fill="currentColor"
    />
    <path
      d="M42.1701 7.17654L42.3284 6.9802V5.07617H31.1068V7.46947H38.7691L31.0325 17.1074L30.8743 17.3038V19.2088H42.4324V16.8155H34.4325L42.1701 7.17654Z"
      fill="currentColor"
    />
    <path
      d="M54.0395 14.3104C53.3345 16.6804 51.1173 16.9362 50.1967 16.9362C47.5357 16.9362 45.9005 15.3611 45.6616 12.5964H56.6092V11.673C56.5253 7.54976 53.9068 4.88477 49.9366 4.88477C46.6236 4.88477 43.0569 7.17087 43.0569 12.191C43.0569 16.4076 45.9929 19.3528 50.1956 19.3528C53.4215 19.3528 55.8521 17.5623 56.537 14.6808L56.7472 13.7978H54.1903L54.0374 14.3104H54.0395ZM45.9132 10.2519C46.4834 8.37017 47.9286 7.30141 49.9376 7.30141C52.5805 7.30141 53.5107 9.20438 53.8218 10.2519H45.9132Z"
      fill="currentColor"
    />
    <path d="M60.744 0H58.1765V19.209H60.9999L60.744 0Z" fill="currentColor" />
    <path
      d="M11.667 6.3181C11.667 8.32189 10.1326 9.95209 8.17351 10.0285C8.11723 10.0306 8.05989 10.0349 8.00361 10.0317C4.34981 9.81518 3.25293 6.17588 3.25293 6.17588V7.62884C3.25293 9.82579 4.76924 11.7723 6.85682 12.2573C6.92266 12.2732 6.99061 12.287 7.05963 12.3008C8.91573 12.65 10.2324 12.2679 11.0107 11.8848C11.1552 11.8137 11.3176 11.8222 11.4557 11.9071C11.5979 11.9951 11.6797 12.1405 11.6808 12.3061L11.7381 19.2079H14.2748V0H11.667V6.3181Z"
      fill="currentColor"
    />
    <path d="M2.60895 0H0V19.209H2.60895V0Z" fill="currentColor" />
  </svg>
);

export const SvgSideCoupon: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 26 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3_542)">
      <path d="M9.10716 11.8109C8.63911 11.8109 8.2583 12.1478 8.2583 12.5618C8.2583 12.9759 8.63911 13.3127 9.10716 13.3127C9.57522 13.3127 9.95603 12.9759 9.95603 12.5618C9.95603 12.1478 9.57532 11.8109 9.10716 11.8109Z" />
      <path d="M19.2937 11.8109C18.8256 11.8109 18.4448 12.1478 18.4448 12.5618C18.4448 12.9759 18.8256 13.3127 19.2937 13.3127C19.7617 13.3127 20.1425 12.9759 20.1425 12.5618C20.1425 12.1478 19.7618 11.8109 19.2937 11.8109Z" />
      <path d="M24.0961 15.9303L25.2533 14.9059C26.2485 14.0266 26.2495 12.6003 25.2533 11.7201L14.8006 2.47344L12.3999 4.59736C12.0683 4.89065 11.5312 4.8907 11.1995 4.59736C10.868 4.30429 10.868 3.82883 11.1995 3.53549L13.6002 1.41158L12.7514 0.660614C11.7587 -0.217971 10.1479 -0.221565 9.14973 0.660929L7.99135 1.68488L7.40665 1.31652C5.75651 0.277294 3.43615 0.404334 1.94704 1.72253C0.476457 3.02365 0.283589 5.05493 1.48838 6.55264L1.90397 7.06987L0.746716 8.09432C-0.248397 8.97357 -0.249413 10.3999 0.746716 11.2801L1.59558 12.0311L3.99627 9.90737C4.32782 9.61407 4.86504 9.61407 5.19664 9.90737C5.5282 10.2004 5.5282 10.6761 5.19664 10.9692L2.79595 13.0929L13.2488 22.3396C14.2414 23.2183 15.8522 23.2219 16.8504 22.3394L18.0088 21.3151L18.594 21.6848C20.2261 22.7167 22.5479 22.6098 24.0531 21.2778C25.5236 19.9766 25.7166 17.9453 24.5117 16.4476L24.0961 15.9303ZM6.39752 7.78341L8.79822 5.65945C9.12977 5.36615 9.66699 5.36615 9.99859 5.65945C10.3301 5.95252 10.3301 6.42798 9.99859 6.72132L7.5979 8.84528C7.26634 9.13857 6.72918 9.13862 6.39752 8.84528C6.06597 8.55221 6.06597 8.07671 6.39752 7.78341ZM9.10717 14.8147C7.70291 14.8147 6.56058 13.8042 6.56058 12.562C6.56058 11.3198 7.70291 10.3092 9.10717 10.3092C10.5114 10.3092 11.6538 11.3198 11.6538 12.562C11.6538 13.8042 10.5115 14.8147 9.10717 14.8147ZM15.0493 17.8184C15.0493 18.2332 14.669 18.5693 14.2004 18.5693C13.7318 18.5693 13.3515 18.2332 13.3515 17.8184V7.30553C13.3515 6.89072 13.7318 6.55461 14.2004 6.55461C14.669 6.55461 15.0493 6.89072 15.0493 7.30553V17.8184ZM19.2936 14.8147C17.8894 14.8147 16.747 13.8042 16.747 12.562C16.747 11.3198 17.8894 10.3092 19.2936 10.3092C20.6979 10.3092 21.8402 11.3198 21.8402 12.562C21.8402 13.8042 20.6979 14.8147 19.2936 14.8147Z" />
    </g>
    <defs>
      <clipPath id="clip0_3_542">
        <rect width="26" height="23" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgFlower: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M49.996 13.7798C49.9444 12.0401 48.539 10.6401 46.801 10.5818L46.4815 10.5785C45.175 10.5785 39.995 10.7478 34.9205 13.049C32.7147 7.17399 28.4987 3.12436 28.2605 2.89798C26.9913 1.70122 25.0107 1.70012 23.7415 2.89798C23.501 3.12546 19.285 7.17508 17.0793 13.0501C12.0036 10.7478 6.82476 10.5785 5.51824 10.5785L5.19874 10.5818C3.46074 10.6401 2.05541 12.0401 2.00381 13.7798C1.99063 14.2281 1.75568 24.8396 8.40137 31.4915C12.8007 35.895 18.9381 37.2753 22.7061 37.7039V46.7032C22.7061 48.5241 24.1806 50 25.9999 50C27.8191 50 29.2936 48.5241 29.2936 46.7032V37.705C33.065 37.2731 39.199 35.8961 43.5984 31.4915C50.2441 24.8396 50.0102 14.2281 49.996 13.7798ZM25.9988 10.3576C27.2065 12.0039 28.5646 14.2952 29.2354 16.8678C29.1937 16.9096 29.1476 16.9436 29.1059 16.9854C27.8323 18.2591 26.8167 19.68 25.9977 21.1449C25.1797 19.68 24.1631 18.2591 22.8895 16.9854C22.8478 16.9436 22.8027 16.9085 22.761 16.8678C23.433 14.2952 24.7922 12.0039 25.9988 10.3576ZM8.86908 17.4568C10.8816 17.7667 13.4672 18.425 15.7607 19.7712C15.7607 19.8306 15.7519 19.8888 15.7519 19.9493C15.7519 23.7857 17.031 27.2661 18.5626 30.0772C16.6226 29.4145 14.632 28.4057 13.0576 26.8287C10.3743 24.1417 9.29947 20.2526 8.86908 17.4568ZM38.9399 26.8287C37.3655 28.4057 35.3761 29.4156 33.4361 30.0772C34.9677 27.265 36.2467 23.7857 36.2467 19.9493C36.2467 19.8888 36.2391 19.8317 36.238 19.7712C38.5315 18.425 41.1171 17.7667 43.1285 17.4568C42.6981 20.2548 41.6243 24.1417 38.9399 26.8287Z" />
  </svg>
);

export const SvgVape: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 30C16 28.8954 16.8954 28 18 28H30V50C30 51.1046 29.1046 52 28 52H18C16.8954 52 16 51.1046 16 50V30Z"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37 40C37 36.6862 39.6862 34 43 34H47C50.3138 34 53 36.6862 53 40V52H37V40Z"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49 28H40V34H49V28Z"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 17H21V28H30V17Z"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 17V13"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44 28V21"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44 43V34"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgTopical: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 67 67"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M55.2612 25.4713L42.5271 12.69C41.5376 11.6969 39.834 11.7919 38.9392 12.8714L20.0101 35.9381C19.9413 35.9813 14.9853 40.9556 14.9853 40.9556C13.2043 42.7951 14.2368 44.954 14.9853 45.6363L22.4279 53.0201C24.3294 54.8336 26.5234 53.7023 27.0053 53.0201L31.4794 48.5293C31.5826 48.4775 55.0891 28.9775 55.0891 28.9775C55.6742 28.632 56.7153 27.2157 55.2612 25.4713ZM24.7596 50.412L17.6698 43.2959L21.077 39.8761L28.1668 46.9921L24.7596 50.412ZM30.7739 44.5568L23.512 37.268L40.8235 16.1099L51.8539 27.0862L30.7739 44.5568Z" />
  </svg>
);

export const SvgOil: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 28 39"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M25.5339 10.875H1.59489C0.711445 10.875 0 11.5864 0 12.4699V36.7138C0 37.5972 0.711445 38.3086 1.59489 38.3086H25.5417C26.4251 38.3086 27.1366 37.5972 27.1366 36.7138V12.4699C27.1287 11.5864 26.4173 10.875 25.5339 10.875ZM23.939 35.1189H3.18978V14.0648H23.939V35.1189Z" />
    <path d="M6.8408 9.76478H20.5224C21.4059 9.76478 22.1173 9.05334 22.1173 8.16989V1.59489C22.1173 0.711445 21.4059 0 20.5224 0H6.8408C5.95736 0 5.24591 0.711445 5.24591 1.59489V8.16989C5.23809 9.05334 5.95736 9.76478 6.8408 9.76478ZM8.43569 3.18978H18.9276V6.57501H8.43569V3.18978Z" />
  </svg>
);

export const SvgCapsule: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 37 39"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.0363 20.0144L20.0467 20.0283C21.3125 21.7253 21.9963 23.7738 21.9963 25.9242C21.9963 28.1089 21.2889 30.187 19.9849 31.8991L19.6388 32.3535L19.2342 31.9504L6.00453 18.7712L5.59688 18.3651L6.05588 18.0181C7.77415 16.7191 9.8593 16.015 12.0511 16.015C14.706 16.015 17.2048 17.0459 19.0828 18.9168M20.0363 20.0144L20.0249 20.0012C20.025 20.0013 20.0252 20.0015 20.0253 20.0016M20.0363 20.0144L20.0334 20.0111M20.0363 20.0144L20.0373 20.0163M19.0828 18.9168L18.7299 19.271L19.0828 18.9168C19.0828 18.9168 19.0828 18.9168 19.0828 18.9168ZM19.0828 18.9168C19.4287 19.2614 19.7459 19.6272 20.0334 20.0111M20.0334 20.0111L20.0322 20.0096C20.0303 20.0072 20.028 20.0044 20.0255 20.0014L20.0253 20.0016M20.0334 20.0111C20.0342 20.0122 20.035 20.0132 20.0359 20.0143C20.0361 20.0147 20.0364 20.015 20.0366 20.0153L20.0393 20.0188L20.0373 20.0163M20.0253 20.0016L20.0053 20.018L19.6392 20.3187L19.7659 20.224L20.0397 20.0194C20.0389 20.0184 20.0381 20.0173 20.0373 20.0163M20.0253 20.0016L20.0373 20.0163M19.044 16.7683L19.8468 17.3792V16.3704V8.79286C19.8468 4.22246 23.5808 0.5 28.1734 0.5C32.766 0.5 36.5 4.22246 36.5 8.79286V30.2071C36.5 34.7775 32.766 38.5 28.1734 38.5C25.06 38.5 22.3402 36.7884 20.9114 34.2585L20.5921 33.693L20.127 34.1463C17.9554 36.2635 15.0951 37.4291 12.051 37.4291C8.964 37.4291 6.06472 36.2326 3.88254 34.0587C1.70043 31.885 0.5 28.9977 0.5 25.9242C0.5 22.8508 1.70043 19.9635 3.88254 17.7897C6.06472 15.6159 8.964 14.4193 12.051 14.4193C14.6131 14.4193 17.0438 15.2461 19.044 16.7683ZM34.3944 18.7022H34.8944V18.2022V8.79286C34.8944 5.09774 31.8779 2.09567 28.1734 2.09567C24.4689 2.09567 21.4524 5.09774 21.4524 8.79286V18.2022V18.7022H21.9524H34.3944ZM4.86774 19.8981L4.46314 19.495L4.1171 19.9493C2.81309 21.6615 2.10563 23.7395 2.10563 25.9242C2.10563 28.5708 3.1412 31.061 5.01934 32.9319C6.89727 34.8027 9.39615 35.8336 12.051 35.8336C14.2428 35.8336 16.3279 35.1295 18.0462 33.8305L18.5052 33.4835L18.0976 33.0774L4.86774 19.8981ZM21.8749 31.9787L21.7479 32.1823L21.8272 32.4087C22.7431 35.0228 25.2404 36.9043 28.1734 36.9043C31.878 36.9043 34.8944 33.9023 34.8944 30.2073V20.7979V20.2979H34.3944H22.955H22.1643L22.5033 21.0123C23.2223 22.5274 23.6021 24.1958 23.6021 25.9244C23.6021 28.0991 22.9983 30.1783 21.8749 31.9787Z" />
  </svg>
);

export const SvgLog: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.4077 3.5H7.15771V22.75H10.6577V19.25V17.4125V7H24.9552L31.6577 13.7025V17.4125V19.25V22.75H35.1577V12.25L26.4077 3.5ZM7.01965 36.75V26.2522H9.38295V34.8979H13.8947V36.75H7.01965ZM19.5844 26.067C21.234 26.067 22.4984 26.5906 23.3775 27.6376C24.2221 28.6402 24.6444 29.9293 24.6444 31.5048C24.6444 33.2285 24.1455 34.5991 23.1478 35.6165C22.2885 36.4956 21.1006 36.9352 19.5844 36.9352C17.9348 36.9352 16.6704 36.4117 15.7913 35.3646C14.9467 34.362 14.5244 33.0532 14.5244 31.4381C14.5244 29.749 15.0232 28.3957 16.0209 27.3783C16.8852 26.5041 18.0731 26.067 19.5844 26.067ZM19.577 27.9191C18.7225 27.9191 18.0632 28.2747 17.5989 28.9859C17.1791 29.628 16.9692 30.4528 16.9692 31.4604C16.9692 32.626 17.2186 33.5298 17.7175 34.1719C18.1867 34.7794 18.809 35.0831 19.5844 35.0831C20.4339 35.0831 21.0957 34.725 21.5698 34.0089C21.9897 33.3767 22.1996 32.542 22.1996 31.5048C22.1996 30.3639 21.9501 29.4724 21.4513 28.8304C20.9821 28.2229 20.3573 27.9191 19.577 27.9191ZM35.231 30.8751V36.2314C34.6285 36.4339 34.2037 36.5673 33.9568 36.6315C33.1912 36.834 32.3689 36.9352 31.4898 36.9352C29.7611 36.9352 28.4449 36.5006 27.5411 35.6313C26.5384 34.6732 26.0371 33.3372 26.0371 31.6234C26.0371 29.6527 26.6594 28.1661 27.9041 27.1635C28.8079 26.4325 30.0278 26.067 31.5638 26.067C32.8776 26.067 34.1 26.3066 35.231 26.7856L34.4235 28.6303C33.8901 28.3636 33.4234 28.1772 33.0233 28.071C32.6232 27.9648 32.1837 27.9117 31.7046 27.9117C30.5588 27.9117 29.7142 28.2846 29.1709 29.0304C28.7116 29.6626 28.4819 30.4948 28.4819 31.527C28.4819 32.7667 28.8277 33.7002 29.5191 34.3274C30.0723 34.8312 30.7588 35.0831 31.5787 35.0831C32.0577 35.0831 32.5121 35.0016 32.9418 34.8386V32.7272H31.1341V30.8751H35.231Z"
      fill="black"
      fillOpacity="0.25"
    />
  </svg>
);

export const SvgMedicine: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 29 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.37354 15.2041H15.382V27.1003C15.382 30.1365 12.914 32.6045 9.87776 32.6045C6.84156 32.6045 4.37354 30.1365 4.37354 27.1003V15.2041Z"
      fill="#FFE8C0"
      stroke="black"
      strokeWidth="0.862812"
      strokeMiterlimit="10"
    />
    <path
      d="M23.8479 24.082C23.7946 24.082 23.7413 24.082 23.6881 24.082C20.4992 23.9754 18.5674 20.5025 20.0659 17.6864L23.8656 10.5913L27.6476 17.6864C29.1461 20.5025 27.2143 23.9754 24.0254 24.082C23.9722 24.082 23.9189 24.082 23.8656 24.082H23.8479Z"
      stroke="#020302"
      strokeWidth="0.862812"
      strokeMiterlimit="10"
    />
    <path
      d="M4.37354 3.84082H15.382V27.1006C15.382 30.1368 12.914 32.6048 9.87776 32.6048C6.84156 32.6048 4.37354 30.1368 4.37354 27.1006V3.84082Z"
      stroke="#020302"
      strokeWidth="0.862812"
      strokeMiterlimit="10"
    />
    <path
      d="M4.37355 3.84089H2.42044C1.63595 3.84089 1 3.20493 1 2.42044V2.42044C1 1.63595 1.63595 1 2.42044 1H17.3351C18.1196 1 18.7556 1.63595 18.7556 2.42044V2.42044C18.7556 3.20493 18.1196 3.84089 17.3351 3.84089H15.382"
      stroke="#020302"
      strokeWidth="0.862812"
      strokeMiterlimit="10"
    />
  </svg>
);

export const SvgDefault: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.37377 4C1.62286 3.45366 1.97429 2.94184 2.42806 2.49293C4.44013 0.502357 7.70235 0.502357 9.71443 2.49293L14.572 7.29858C15.3449 8.06328 15.8209 9.01053 16 10M1 7.00001C1.17909 7.98948 1.6551 8.93673 2.42806 9.70144L7.28562 14.5071C9.2977 16.4976 12.5599 16.4976 14.572 14.5071C15.0258 14.0582 15.3771 13.5464 15.6263 13"
      stroke="#fff"
      stroke-linecap="round"
    />
    <path d="M12 5C12 5 11.6061 7.04337 9.32457 9.32494C7.04303 11.6064 5 12 5 12" stroke="#fff" />
  </svg>
);

export const SvgPin: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4831 4.7914L10.1544 1.44983C9.68386 1.20139 9.10103 1.38143 8.8526 1.85195C8.60417 2.32247 8.78421 2.90529 9.25473 3.15373L15.5835 6.4953C16.054 6.74373 16.6368 6.5637 16.8853 6.09318C17.1337 5.62266 16.9537 5.03983 16.4831 4.7914Z"
      fill="#FFE8C0"
      stroke="black"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
    <path
      d="M6.34296 14.5342L2.56258 22.4958C2.36113 22.9186 2.96953 23.246 3.21107 22.8475L7.82535 15.3169"
      fill="#FFE8C0"
    />
    <path
      d="M6.34296 14.5342L2.56258 22.4958C2.36113 22.9186 2.96953 23.246 3.21107 22.8475L7.82535 15.3169"
      stroke="black"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
    <path
      d="M10.2857 3.85401L7.85154 8.46428C5.1695 7.91974 2.34178 9.17214 1.00001 11.7134L13.1707 18.1395C14.5125 15.5982 13.9519 12.5568 11.9896 10.6492L14.4238 6.03889"
      stroke="black"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const SvgIHIVerified: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2431 4.27956C3.43562 3.81064 3.81038 3.4358 4.27925 3.24318C3.82609 2.78426 3.19647 2.5 2.5 2.5C2.5 1.11848 3.61848 0 5 0C6.38152 0 7.49999 1.11848 7.49999 2.5C6.80362 2.5 6.17408 2.78418 5.72093 3.24299C6.18987 3.43549 6.56472 3.81024 6.75735 4.2791C7.21596 3.82598 7.5 3.19658 7.5 2.50039C8.88152 2.50039 9.99999 3.61886 9.99999 5.00038C9.99999 6.3819 8.88152 7.50038 7.5 7.50038C7.5 6.80414 7.21592 6.1747 6.75726 5.72157C6.56464 6.19024 6.18994 6.56485 5.72121 6.75736C6.17434 7.216 6.80376 7.50006 7.49999 7.50006C7.49999 8.88158 6.38152 10.0001 5 10.0001C3.61848 10.0001 2.5 8.88158 2.5 7.50006C3.19633 7.50006 3.82583 7.21592 4.27897 6.75717C3.8103 6.56454 3.4357 6.18984 3.24319 5.72112C2.78426 6.17428 2.5 6.8039 2.5 7.50038C1.11848 7.50038 0 6.3819 0 5.00038C0 3.61886 1.11848 2.50039 2.5 2.50039C2.5 3.19682 2.78423 3.8264 3.2431 4.27956Z"
    />
  </svg>
);

export const SvgStripeLogo = ({ className }: ISvg) => (
  <svg
    className={clsx(className, 'fill-current')}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    viewBox="0 0 468 222.5"
  >
    <style>{`.st0{fillRule:evenodd;clipRule:evenodd;`}</style>
    <path
      className="st0"
      d="M414 113.4c0-25.6-12.4-45.8-36.1-45.8-23.8 0-38.2 20.2-38.2 45.6 0 30.1 17 45.3 41.4 45.3 11.9 0 20.9-2.7 27.7-6.5v-20c-6.8 3.4-14.6 5.5-24.5 5.5-9.7 0-18.3-3.4-19.4-15.2h48.9c0-1.3.2-6.5.2-8.9zm-49.4-9.5c0-11.3 6.9-16 13.2-16 6.1 0 12.6 4.7 12.6 16h-25.8zM301.1 67.6c-9.8 0-16.1 4.6-19.6 7.8l-1.3-6.2h-22v116.6l25-5.3.1-28.3c3.6 2.6 8.9 6.3 17.7 6.3 17.9 0 34.2-14.4 34.2-46.1-.1-29-16.6-44.8-34.1-44.8zm-6 68.9c-5.9 0-9.4-2.1-11.8-4.7l-.1-37.1c2.6-2.9 6.2-4.9 11.9-4.9 9.1 0 15.4 10.2 15.4 23.3 0 13.4-6.2 23.4-15.4 23.4zM223.8 61.7l25.1-5.4V36l-25.1 5.3zM223.8 69.3h25.1v87.5h-25.1zM196.9 76.7l-1.6-7.4h-21.6v87.5h25V97.5c5.9-7.7 15.9-6.3 19-5.2v-23c-3.2-1.2-14.9-3.4-20.8 7.4zM146.9 47.6l-24.4 5.2-.1 80.1c0 14.8 11.1 25.7 25.9 25.7 8.2 0 14.2-1.5 17.5-3.3V135c-3.2 1.3-19 5.9-19-8.9V90.6h19V69.3h-19l.1-21.7zM79.3 94.7c0-3.9 3.2-5.4 8.5-5.4 7.6 0 17.2 2.3 24.8 6.4V72.2c-8.3-3.3-16.5-4.6-24.8-4.6C67.5 67.6 54 78.2 54 95.9c0 27.6 38 23.2 38 35.1 0 4.6-4 6.1-9.6 6.1-8.3 0-18.9-3.4-27.3-8v23.8c9.3 4 18.7 5.7 27.3 5.7 20.8 0 35.1-10.3 35.1-28.2-.1-29.8-38.2-24.5-38.2-35.7z"
    />
  </svg>
);

export const SvgDownArrow: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 0.5L4 3.5L7 0.5" stroke="#0F5342" strokeLinecap="round" />
  </svg>
);

export const SvgChat: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 7.5C10.5 7.76522 10.3946 8.01957 10.2071 8.20711C10.0196 8.39464 9.76522 8.5 9.5 8.5H3.5L1.5 10.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H9.5C9.76522 1.5 10.0196 1.60536 10.2071 1.79289C10.3946 1.98043 10.5 2.23478 10.5 2.5V7.5Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);


export const SvgMoon: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.72165 8.16129C5.52577 8.16129 3.75258 6.2674 3.75258 3.92207C3.75258 2.23739 4.6701 0.79495 6 0.11227C5.72165 0.0682259 5.4433 0.035193 5.15464 0.035193C2.30928 0.024182 0 2.49064 0 5.52967C0 8.5687 2.30928 11.0352 5.15464 11.0352C7.39175 11.0352 9.28866 9.51564 10 7.39052C9.35052 7.87501 8.56701 8.16129 7.72165 8.16129Z"
      fill="#29251F"
    />
  </svg>
);

export const SvgTerpene: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5641 5.58471C11.4099 4.40753 11.6757 2.85798 11.1441 1.40453L8.94517 2.19732C8.94517 2.12525 8.95725 2.05317 8.95725 1.96909C8.95725 0.900021 8.08736 0.0351562 7.01208 0.0351562C5.9368 0.0351562 5.06691 0.900021 5.06691 1.96909C5.06691 2.52164 5.30855 3.02615 5.68309 3.3745L2.60223 4.49161C2.74721 4.88801 2.94052 5.24837 3.18216 5.57269H0.5C0.5 9.14026 3.41171 12.0352 7 12.0352C10.5883 12.0352 13.5 9.14026 13.5 5.57269H10.5641V5.58471Z"
      fill="#29251F"
    />
  </svg>
);

export const SvgFormulary: FC<ISvg & { fill?: '#d9d9d9' | '#c2da49' }> = ({
  className,
  fill = '#29251F'
}) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0014 5.32276C21.0014 10.8023 16.5308 15.245 11.0042 15.2956C11.0042 15.2956 10.9787 15.2956 10.9616 15.2956C10.9446 15.2956 10.9361 15.2956 10.9191 15.2956C5.39251 15.245 0.921875 10.8023 0.921875 5.32276H6.09078C8.66245 5.32276 10.7487 7.28698 10.9616 9.78229C11.166 7.28698 13.2523 5.32276 15.8325 5.32276H21.0014ZM12.6903 5.92973C14.206 4.98556 14.6659 3.00449 13.7121 1.50393C12.7584 0.0033735 10.7573 -0.451852 9.24151 0.492319C7.72575 1.43649 7.26591 3.41756 8.21965 4.91812C9.17338 6.41868 11.1745 6.8739 12.6903 5.92973Z"
      fill={fill}
      // fill="#C2DA49"
    />
  </svg>
);

export const SvgSimilarProduct: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.8269 6.03592C22.8269 12.2496 17.7446 17.2875 11.4618 17.3449C11.4618 17.3449 11.4328 17.3449 11.4134 17.3449C11.3941 17.3449 11.3844 17.3449 11.365 17.3449C5.08232 17.2875 0 12.2496 0 6.03592H5.87613C8.79968 6.03592 11.1714 8.2633 11.4134 11.0929C11.6458 8.2633 14.0175 6.03592 16.9508 6.03592H22.8269ZM13.3786 6.72421C15.1018 5.65354 15.6245 3.40704 14.5403 1.70543C13.4561 0.00382549 11.1811 -0.512392 9.45796 0.558281C7.73481 1.62895 7.21206 3.87545 8.29628 5.57706C9.38051 7.27866 11.6555 7.79488 13.3786 6.72421Z"
      fill="#29251F"
    />
  </svg>
);